import React from 'react'
import { Box, HStack, Text, Icon } from '@chakra-ui/react'
import { CheckCircleIcon } from '@chakra-ui/icons'

export const PaymentMethodSection = () => (
  <Box bg="white" borderRadius="8px" p="16px">
    <Text fontSize="xs" fontWeight="600" mb="12px" color="externalPayment.cardInputText">
      決済手段
    </Text>
    <HStack bg="bg.secondary" border="1px solid" borderColor="externalPayment.cardInputBorder" borderRadius="4px" h="48px" px="12px" spacing={3}>
      <Icon as={CheckCircleIcon} color="label.accent" boxSize="20px" />
      <Text fontSize="xs" fontWeight="400" color="externalPayment.cardInputText" flex="1">
        クレジットカード
      </Text>
      <Text fontSize="xs" fontWeight="400" color="externalPayment.cardInputPlaceholder">
        Mastercard 1234
      </Text>
    </HStack>
  </Box>
)
